/** @format */
import { Component, Inject, Input, OnInit } from '@angular/core';
import { IHomrSpot } from '@shared/data-access/interfaces';
import { WINDOW } from '@shared/data-access/services';

@Component({
	selector: 'pdp-homr-text-link',
	templateUrl: './homr-text-link.component.html',
	styleUrl: './homr-text-link.component.scss'
})
export class HomrTextLinkComponent implements OnInit {
	/**
	 * @description
	 * The homr content to be displayed
	 */
	@Input() homrContent: IHomrSpot[];

	@Input() homrSpotName: string;

	public message;
	public link;
	public border;

	constructor(@Inject(WINDOW) protected window: Window) {}

	ngOnInit() {
		if (this.homrContent) {
			for (let i = 0, length = this.homrContent.length; i < length; i++) {
				if (this.homrContent[i].contentName === this.homrSpotName) {
					this.message = this.homrContent[i].message;
					this.link = this.homrContent[i].link;
					this.border = this.homrContent[i].border;
				}
			}
		}
	}
}
